export default __webpack_public_path__ + "static/media/plain-sticker-Y.f415a392.png";